import React from 'react';
import Recommendation from './recommendation';
import { recShape } from './recommendation_mapper';
import LinkedStory from './linked_story';

const LowFinishRateRecommendation = ({ rec }) => {
  const headline = 'Create multimedia to increase engagement';
  const finishRate = (
    <strong>
      {rec.finishRate}
      %
    </strong>
  );

  return (
    <Recommendation headline={headline} rec={rec}>
      <LinkedStory
        id={rec.id}
        href={rec.primaryItem.link}
        title={rec.primaryItem.title}
      />
      {' has brought in above-average traffic to your site, but most people only read '}
      {finishRate}
      {' of the story. Consider creating a related video or an infographic to increase engagement.'}
    </Recommendation>
  );
};

export default LowFinishRateRecommendation;

LowFinishRateRecommendation.propTypes = {
  rec: recShape.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/low_finish_rate_recommendation.jsx